import { useEffect } from 'react';
import { useFetchUserParameters } from './useFetchUserParameters';
import { useFetchWorkTimeTypeById } from './useFetchWorkTimeTypeById';
import { useWorkTime } from '../context/WorkTimeContext';
import { IWorkTime } from '../interface/workTimes';
import { ParameterEntityType } from '../interface/parameters';
import { getTranslationFromTranslatableEntity } from '../constants/matter';
import { useLanguage } from '../context/LanguageContext';

interface UseWorkTimeDefaultsParams {
  enabled: boolean;
}

export const useWorkTimeDefaults = ({ enabled }: UseWorkTimeDefaultsParams) => {
  const { workTime, updateWorkTime } = useWorkTime();
  const { getAppLanguageCode } = useLanguage();

  // Fetch user default parameters
  const { data: defaultParameters, isLoading: isLoadingParameters } = useFetchUserParameters({
    parametersToGet: ParameterEntityType.DEFAULT,
    enabled,
  });

  // Fetch default work time type based on user parameters
  const { data: defaultWorkTimeType, isLoading: isLoadingWorkTimeType } = useFetchWorkTimeTypeById({
    id: defaultParameters?.parameters?.defaultParametersResponse?.workTimeTypeId,
  });

  // Apply default work time type to the work time context when loaded
  useEffect(() => {
    if (defaultWorkTimeType && !workTime?.workTimeType && enabled) {
      const workTimeTypeTranslation = getTranslationFromTranslatableEntity(
        defaultWorkTimeType?.translations,
        getAppLanguageCode(),
      );
      const payload = {
        ...workTime,
        workTimeType: defaultWorkTimeType,
        subject: workTimeTypeTranslation || workTime?.subject || '',
      } as IWorkTime;
      updateWorkTime(payload);
    }
  }, [defaultWorkTimeType, enabled]);

  return {
    defaultWorkTimeType,
    isLoadingDefaults: isLoadingParameters || isLoadingWorkTimeType,
  };
};
